import { beRecipientApiAddRecipient } from 'Api/beRecipientApiTS'

import type { AddRecipientResult } from 'Types/beRecipientsApi'

import { STORE_KEY_ID_LIST, storeGet } from 'mailup-react-helpers'

import type {
  GroupInfo,
  NewRecipient,
  PanelAddRecipientGroupsPagingState,
  PanelAddRecipientState,
} from 'Pages/RecipientsList/model'

export const newRecipientAddGroupsUpdater =
  (newGroupId: number) =>
  (prev: PanelAddRecipientState): PanelAddRecipientState => {
    return {
      ...prev,
      recipient: {
        ...prev.recipient,
        Groups: [...prev.recipient.Groups, newGroupId],
      },
    }
  }

export const newRecipientRemoveGroupUpdater =
  (groupId: number) =>
  (prev: PanelAddRecipientState): PanelAddRecipientState => {
    return {
      ...prev,
      recipient: {
        ...prev.recipient,
        Groups: prev.recipient.Groups.filter((g) => g !== groupId),
      },
    }
  }

export const groupsLoaderUpdater =
  (loading: boolean) =>
  (
    prev: PanelAddRecipientGroupsPagingState,
  ): PanelAddRecipientGroupsPagingState => ({
    ...prev,
    loading,
  })

export const groupsAddUpdater =
  (g: GroupInfo) =>
  ({
    items,
    ...prev
  }: PanelAddRecipientGroupsPagingState): PanelAddRecipientGroupsPagingState => ({
    ...prev,
    items: [...items, g],
  })

export const groupsRemoveGroupUpdater =
  (groupId: number) =>
  ({
    items,
    ...prev
  }: PanelAddRecipientGroupsPagingState): PanelAddRecipientGroupsPagingState => ({
    ...prev,
    items: items.filter((g) => g.Id !== groupId),
    pageNumber: 1,
  })

export const addRecipient = async (
  { Email, MobileNumber, MobilePrefix, Fields, Groups }: NewRecipient,
  pending: boolean,
): Promise<{
  ResultCode: AddRecipientResult['ResultCode']
  newRecipientId: number | undefined
  existingRecipientId: number | undefined
}> => {
  const idList: number = storeGet(STORE_KEY_ID_LIST)

  const { ResultCode, RecipientDetails } = await beRecipientApiAddRecipient(
    idList,
    {
      webhookSource: 'CONSOLE',
      status: pending ? 1 : 0,
    },
    {
      Email,
      MobileNumber,
      MobilePrefix,
      Fields: Fields.filter((o) => o.value !== '').map((o) => ({
        Id: o.id,
        Value: o.value,
      })),
      Groups,
    },
  )

  return {
    ResultCode,
    newRecipientId:
      ResultCode === 'OK' ? RecipientDetails.RecipientId : undefined,
    existingRecipientId:
      ResultCode === 'EXISTING' ? RecipientDetails.RecipientId : undefined,
  }
}
